export const MENU_ITEM_PROPERTY_NAME = {
    iconName: 'iconName',
    labelText: 'labelText',
    mainRoute: 'mainRoute',
    secondaryRoutes: 'secondaryRoutes',
    disabled: 'disabled',
    hideOnWindowSize: 'hideOnWindowSize',
    hideFromMenuArea: 'hideFromMenuArea',
};
